var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { autoinject } from "aurelia-framework";
var AdornerService = /** @class */ (function () {
    function AdornerService() {
        this._showFuncs = [];
        this._hideFuncs = [];
    }
    // SHOW ADORNER FUNCTIONS
    AdornerService.prototype.onAdd = function (funcShow) {
        this._showFuncs.push(funcShow);
    };
    AdornerService.prototype.add = function (model) {
        var e_1, _a;
        try {
            for (var _b = __values(this._showFuncs), _c = _b.next(); !_c.done; _c = _b.next()) {
                var func = _c.value;
                func(model);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
    };
    // HIDE ADORNER FUNCTIONS
    AdornerService.prototype.onRemove = function (funcHide) {
        this._hideFuncs.push(funcHide);
    };
    AdornerService.prototype.remove = function (model) {
        var e_2, _a;
        try {
            for (var _b = __values(this._hideFuncs), _c = _b.next(); !_c.done; _c = _b.next()) {
                var func = _c.value;
                func(model);
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_2) throw e_2.error; }
        }
    };
    AdornerService = __decorate([
        autoinject,
        __metadata("design:paramtypes", [])
    ], AdornerService);
    return AdornerService;
}());
export { AdornerService };
